"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _VolumeMute = _interopRequireDefault(require("@material-ui/icons/VolumeMute"));

var _VolumeDown = _interopRequireDefault(require("@material-ui/icons/VolumeDown"));

var _VolumeUp = _interopRequireDefault(require("@material-ui/icons/VolumeUp"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

const MediaButtonPlayPause = ({
  className,
  muted,
  onClick
}) => {
  const classes = useStyles();

  if (muted) {
    return _react.default.createElement(_IconButton.default, {
      className: className || classes.root,
      onClick: onClick
    }, _react.default.createElement(_VolumeMute.default, null));
  }

  return _react.default.createElement(_IconButton.default, {
    className: className || classes.root,
    onClick: onClick
  }, _react.default.createElement(_VolumeUp.default, null));
};

var _default = MediaButtonPlayPause;
exports.default = _default;
module.exports = exports.default;